import { Location } from './incidence.model';

export class UserModel {
  id: string;
  displayName: string; //
  firstName: string; //
  lastName: string; //
  email: string;
  emailVerified: boolean;
  phoneNumber?: string;  
  phoneNumberVerified: false;
  address?: string; //
  location:Location;
  locationUpdated: Date;
  photoURL: string;
  uid: string;
  regStatus: UserModel.RegStatus;
  provider:{
    // facebook.com:1278172
    // password:email
  }  
disabled: boolean; // XA: 17/sept/20

}

export namespace UserModel{
  export enum RegStatus {
    Completed,
    Location,
    Name
  }
}